// @flow
import _, { inRange, isEmpty } from 'lodash';
import { createSelector } from 'reselect';
import { createWinLossRecord,
	createWinLossForm, leagueStatsSelected, gamesPlayed } from "../../../helpers/team";
import type { TPLeague } from '../../types';
import {  transactionPlayerName } from "../../../helpers/league";
// @flow
import { getPlayerById } from '../players';
import { getLastCompleteRound, getRounds, getRoundsWithMatches } from '../rounds';
import isPendingShowToJoin from './isPendingShowToJoin';
import { getShowToJoinOffset } from './getShowToJoinOffset';
import getLeague from './getLeague';
import isLeagueStarted from './isLeagueStarted';
import getLeagueDraftOrder from './getLeagueDraftOrder';
import getDraftOrder from './getDraftOrder';
import getById from './getById';
import getTeamsById from './getTeamsById';
import getWaiversList from './getWaiversList';
import getWaiversListIds from './getWaiversListIds';
import getWaiversFree from './getWaiversFree';
import getTeamsByIdWithPureLineups from './getTeamsByIdWithPureLineups';
import getCommissionerName from './getCommissionerName';
import getLeagueUserTeamId from './getLeagueUserTeamId';
import getWaiverTrades from './getWaiverTrades';
import getWaiverRequestsByTeamId from './getWaiverRequestsByTeamId';
import getTransactionsHistoryById from './getTransactionsHistoryById';


// grouped selectors
import * as ladder from './ladder';
import * as show from './show';
import * as show_my from './show_my';
import * as rosters from './rosters';

// import { players } from '../../../../../tds-draft-fe-utilities/packages/players/lib/reducers';


const getSelectedRoundId = (state, props) => props.selected_round_id;
const transactionHistory = state => state.leagues.transaction_history.result;
const leagueSelector = (state, props) => {
	return _.get(state, `leagues.by_id.${props.match.params.league_id}`);
};

export const orderedLadderCalculated = createSelector(
	ladder.getOrdered,
	getLastCompleteRound,
	getSelectedRoundId,
	leagueSelector,
	(ladder, last_complete_round, selected_round_id, league) => {
		if(_.isEmpty(league) || _.isEmpty(ladder) || !_.get(ladder, `[0].rank_history`)) {
			return [];
		}
		const last_complete_round_id = _.get(last_complete_round, 'id', 0);

		// ladder should only show the leagues regular season games
		let max_league_round_id = league.end_round;
		// check if finals
		if(league.finals === 1) {
			const number_of_finals_rounds = league.finals_format / 2;
			max_league_round_id = max_league_round_id - number_of_finals_rounds;
		}

		// Pick the lowest value
		const ladder_round_id =
			_.min([max_league_round_id, selected_round_id, last_complete_round_id]);

		return ladder.map(team => ({
			...team,
			games_played: gamesPlayed(team, ladder_round_id),
			...createWinLossRecord(team, ladder_round_id),
			form: createWinLossForm(team, ladder_round_id),
			league_points_selected_round:
				leagueStatsSelected(team.league_scoreflow, ladder_round_id),
			points_for_selected_round: leagueStatsSelected(team.scoreflow, ladder_round_id),
			points_against_selected_round:
				leagueStatsSelected(team.league_against, ladder_round_id),
			points_diff_selected_round:
				leagueStatsSelected(team.scoreflow, ladder_round_id) -
					leagueStatsSelected(team.league_against, ladder_round_id),
			rank_selected_round: team.rank_history[ladder_round_id]
		}));
	});

export const getTransactionPlayerNames = createSelector(
	transactionHistory,
	getPlayerById,
	( transaction, player) => {
		return transaction ? transaction.map(trans => ({
			...trans,
			player_name: transactionPlayerName(trans, player),
		})) : null;
	});

export const isCaptainsEnabled = createSelector(
	getLeague,
	league => league.captains === 1
);



export const getLeagueRounds = createSelector(
	getLeague,
	getRounds,
	(league: TPLeague, rounds: Array<Object>) => {
		if (isEmpty(league) || isEmpty(rounds)) {
			return [];
		}
		const { start_round, end_round } = league;
		return rounds.filter(({ id }) => inRange(id, start_round, end_round + 1));
	}
);

export const getLeagueRoundsWithMatches = createSelector(
	getLeague,
	getRoundsWithMatches,
	(league: TPLeague, rounds: Array<Object>) => {
		if (isEmpty(league) || isEmpty(rounds)) {
			return [];
		}
		const { start_round, end_round } = league;
		return rounds.filter(({ id }) => inRange(id, start_round, end_round + 1));
	}
);


export default {
	isPendingShowToJoin,
	getShowToJoinOffset,
	getLeague,
	getById,
	getTeamsById,
	getWaiversList,
	getWaiversListIds,
	getWaiversFree,
	getTeamsByIdWithPureLineups,
	isLeagueStarted,
	getLeagueDraftOrder,
	getDraftOrder,
	getCommissionerName,
	getLeagueUserTeamId,
	getWaiverTrades,
	getWaiverRequestsByTeamId,
	getTransactionsHistoryById,

	// grouped selectors
	ladder,
	show,
	show_my,
	rosters,
	
};


// WEBPACK FOOTER //
// ./src/modules/selectors/league/index.js